const premiumReducer = (state, action) => {
    if (state === undefined) {
        state = {
            history: null,
            current: null
        };
        return state;
    }
    switch (action.type) {
        case "SET_PREMIUM_HISTORY":
            return {
                ...state,
                history: action.history,
                current: action.current
            };
        default:
            return state
    }
};
export default premiumReducer;
